<template>
    <div>
        <div class="jd-block__title">鉴定信息 <small>（在线鉴定有局限性，结果仅供参考）</small></div>
        <k-cell-group v-if="info">
            <k-cell size="small">
                <k-row>
                    <k-col span="6"><span class="cl-desc">鉴定专家：</span></k-col>
                    <k-col span="18"><router-link :to="`/detail?aid=${info.aid}`" class="cl-blue">{{appraiser.name || ""}}</router-link></k-col>
                </k-row>
                <k-row>
                    <k-col span="6"><span class="cl-desc">藏品名称：</span></k-col>
                    <k-col span="18">{{info.definition || ""}}</k-col>
                </k-row>
                <k-row v-if="cfgPeriods">
                    <k-col span="6"><span class="cl-desc">藏品断代：</span></k-col>
                    <k-col span="18">{{formatPeriods(info.periods||"")}}</k-col>
                </k-row>
                <k-row>
                    <k-col span="24"><span class="cl-desc">价格趋势：</span></k-col>
                    <k-col span="24">
                        <k-price-lv :lv="info.trend || 0" :lv-list="cfgTrend" />
                    </k-col>
                </k-row>
                <k-row v-if="cfgIsReal && info.isReal">
                    <k-col span="6"><span class="cl-desc">鉴定结果：</span></k-col>
                    <k-col span="18">{{realText(info.isReal||'')}}</k-col>
                </k-row>
                <k-row>
                    <k-col span="6"><span class="cl-desc">鉴定评语：</span></k-col>
                    <k-col span="18">{{info.reply || ""}}</k-col>
                </k-row>
                <k-row v-if="info.isReal != CONST.IS_REAL_FALSE">
                    <k-col span="6"><span class="cl-desc">鉴定证书：</span></k-col>
                    <k-col span="18"><router-link :to="`/certificate?orderId=${info.id}`" class="cl-blue">查看证书</router-link></k-col>
                </k-row>
            </k-cell>
        </k-cell-group>
        <k-hr />
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex"
    export default {
        name: "expert-result",
        props : ["info", "appraiser"],
        data(){
          return {
              cert : null
          }
        },
        computed : {
            ...mapGetters("jianding",["cfgPeriods","cfgTrend", "cfgIsReal", "CONST"]),
        },
        filters : {

        },
        methods : {
            formatPeriods(value){
                if(!value) return  "";
                return this.cfgPeriods[value] || ""
            },
            realText(value){
                if(!value) return  "";
                return this.cfgIsReal[value] || ""
            }
        }
    }
</script>

<style scoped>

</style>